import { defineAsyncComponent } from 'vue';
import {
  mountVueComponent,
} from '@/components/mountVueComponents';

const searchSuggestEl = document.querySelector('.js-search-suggest');
if (searchSuggestEl) {
  const searchSuggest = defineAsyncComponent(() => import('./SearchSuggester.vue'));
  mountVueComponent(searchSuggestEl, searchSuggest, 'Search-Suggest');
}

const productsSearchEl = document.querySelector('.js-search');
if (productsSearchEl) {
  const productsSearch = defineAsyncComponent(() => import('./ProductsSearch.vue'));
  mountVueComponent(productsSearchEl, productsSearch, 'Products-Search');
}
